import { makeAutoObservable, runInAction } from 'mobx'

import { MerchantApi } from '../api'
import type { Merchant } from '../types'

import { GlobalStore } from './GlobalStore'

export interface CopyObject {
  [key: string]: string
}

export class MerchantStore {
  globalStore: GlobalStore
  api: MerchantApi = new MerchantApi('/', '')

  merchant: Merchant | null = null
  merchants: Merchant[] = []
  isLoading = false

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    this.api = new MerchantApi(globalStore.endpoint, globalStore.sessionToken, globalStore.onError)

    makeAutoObservable(this)
  }

  loadMerchants = async (searchValue = '') => {
    this.isLoading = true

    const merchants = await this.api.getMerchants([searchValue])

    runInAction(() => {
      this.merchants = merchants
      this.isLoading = false
    })
  }

  loadMerchantByGuid = async (guid: string) => {
    const merchant = await this.api.getMerchantByGuid(guid)

    runInAction(() => (this.merchant = merchant))
  }
}
